import { BrowserAuthError, ClientAuthError } from '@azure/msal-browser';
import { notifications } from '../notifications-service';
import {ApiExceptions} from "../../model/api/api-exceptions";

const IgnoredExceptionCodes = [ApiExceptions.CUSTOMER_HAS_NOT_NEXPARK_URL];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const messageExtractors: Array<{ test: (err: unknown) => boolean; messages: (err: any) => string[] }> = [
  {
    test: (err) => err instanceof ClientAuthError && err.message?.startsWith('endpoints_resolution_error'),
    messages: (err) => ['Please check your network connection and try again.'],
  },
  {
    // Ignored Exceptions
    test: (err: any) => IgnoredExceptionCodes.includes(err?.response?.data?.code),
    messages: (err: any) => {
      return [''];
    }
  },
  {
    test: (err: any) => err.response?.status === 403,
    messages: (err) => ['Access denied. You don\'t have the required permissions.'],
  },
  {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    test: (err: any) => err.response?.data?.errors,
    messages: (err: { response: { data: { errors: { [key: string]: string } } } }) =>
      Object.keys(err.response.data.errors).map((key) => err.response.data.errors[key][0]),
  },
  {
    // ArgumentNullException from .NET backend with parameter
    test: (err: any) => err.response?.data?.exceptionDetails,
    messages: (err: { response: { data: { exceptionDetails: [{ message: string }] } } }) => {
      return err.response.data.exceptionDetails.map((exs) => {
        const match = exs.message.match(/\(Parameter '(.*)'\)/);
        return match ? match[1] : exs.message;
      })
    }
  }
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function apiErrorHandler(err: any) {
  if (!(err instanceof BrowserAuthError) && err.status !== 401 && err.code !== 'ERR_CANCELED' && err.code !== 'ECONNABORTED') {
    const messages = messageExtractors.find((e) => e.test(err))?.messages(err) || [err.message];
    messages.forEach((message) => message ? notifications.error(message) : null);
  }
}
